import React from 'react';

import ShareLinkDrawer from './ShareLinkDrawer';
import {
  sharedProfileUrl,
  useMyProfileShare,
  useShareMyProfile,
  useStopSharingMyProfile,
} from '../../hooks/useProfileShare';

// Sharing a member's profile, Instagram style: a link anyone can open at /shared/profile/{code}.
// Its own link, separate from the Courses Played list's, so sharing one never shares the other.

interface ShareProfileDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const ShareProfileDrawer: React.FC<ShareProfileDrawerProps> = ({
  isOpen,
  onClose,
}) => {
  const { data: shareId, isLoading } = useMyProfileShare(isOpen);
  const share = useShareMyProfile();
  const stopSharing = useStopSharingMyProfile();

  return (
    <ShareLinkDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Share your profile"
      shareId={shareId}
      isLoading={isLoading}
      share={share}
      stopSharing={stopSharing}
      buildUrl={sharedProfileUrl}
      intro="Create a link to your profile. Anyone with the link can see it, without an account."
      whatTheySee="They see your first name and last initial, your profile picture, your bio, your course, country and bucket list counts, your primary home club (unless you hid it), your golf index, where you live and your golfer profile. Never your email, phone or date of birth. You can stop sharing at any time."
      sharedText="Anyone with this link can see your profile."
      nativeShareTitle="My GolfPlayed profile"
      stoppedText="Your profile is no longer shared."
      inputId="profile-share-link"
    />
  );
};

export default ShareProfileDrawer;
